import React from 'react';
import { Section } from './ui/Section';
import { Star, Quote } from 'lucide-react';
export const allTestimonials = [{
  id: 'vp',
  initials: 'VP',
  name: 'Valeria P.',
  location: 'Buenos Aires',
  role: 'PROFESORA DE PATINAJE ARTÍSTICO EN CLUB DEPORTIVO',
  text: 'Organicé todo mi año de patinaje en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico antes de la semana.',
  color: 'bg-blue-500'
}, {
  id: 'cr',
  initials: 'CR',
  name: 'Claudia R.',
  location: 'Rosario',
  role: 'PROFE DE PATINAJE EN ACADEMIA PARTICULAR',
  text: 'Las progresiones técnicas cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.',
  color: 'bg-purple-500'
}, {
  id: 'mf',
  initials: 'MF',
  name: 'Marcela F.',
  location: 'Córdoba',
  role: 'INSTRUCTORA DE PATINAJE ARTÍSTICO GRUPAL E INDIVIDUAL',
  text: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mixto de edades y niveles.',
  color: 'bg-emerald-500'
}, {
  id: 'rp',
  initials: 'RP',
  name: 'Romina P.',
  location: 'Tucumán',
  role: 'PROFE PARTICULAR Y EN CLUB',
  text: 'Las Fichas de Evaluación del Tomo 5 eliminaron mi inseguridad al evaluar a mis alumnos. Ahora sé exactamente en qué nivel están y qué necesitan. Mis clases tienen otro nivel de profesionalismo.',
  color: 'bg-rose-500'
}, {
  id: 'mg',
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Mendoza',
  role: 'PROFESORA DE PATINAJE ONLINE Y PRESENCIAL',
  text: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión por niveles. Los alumnos ahora quieren venir porque siempre hay algo nuevo que aprender.',
  color: 'bg-amber-500'
}, {
  id: 'lv',
  initials: 'LV',
  name: 'Laura V.',
  location: 'Santa Fe',
  role: 'INSTRUCTORA EN CLUB Y ACADEMIA MUNICIPAL',
  text: 'El Tomo 6 de gestión me salvó de seguir cobrando lo mismo de siempre. Ahora tengo un sistema profesional visible que me permite justificar mis tarifas ante las familias.',
  color: 'bg-indigo-500'
}, {
  id: 'ar',
  initials: 'AR',
  name: 'Andrea R.',
  location: 'Salta',
  role: 'INSTRUCTORA EN CLUB Y ESPACIO PRIVADO',
  text: 'Los Módulos del Pack Élite me cambiaron la cabeza. Nunca había dimensionado el potencial de llegar a una competencia con todo resuelto. Ahora trabajo con una seguridad que antes no tenía.',
  color: 'bg-teal-500'
}];
interface TestimonialsProps {
  limit?: number;
  title?: string;
  dark?: boolean;
}
export function Testimonials({
  limit = 3,
  title = 'Lo que dicen los profes que ya no improvisan',
  dark = false
}: TestimonialsProps) {
  const displayTestimonials = allTestimonials.slice(0, limit);
  return <Section dark={dark} className={dark ? '' : 'bg-brand-ice/30'} data-id="element-308">
      <div className="text-center mb-6 md:mb-12" data-id="element-309">
        <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3 md:mb-4" data-id="element-310">
          {title}
        </h2>
        <div className="w-16 md:w-24 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-311"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-312">
        {displayTestimonials.map(t => <div key={t.id} className={`p-5 md:p-8 rounded-xl md:rounded-2xl shadow-sm border relative ${dark ? 'bg-brand-light border-slate-700' : 'bg-white border-slate-100'}`} data-id="element-313">
            <Quote className={`absolute top-4 right-4 md:top-6 md:right-6 w-6 h-6 md:w-8 md:h-8 opacity-10 ${dark ? 'text-white' : 'text-brand-dark'}`} data-id="element-314" />

            <div className="flex text-brand-accent mb-2 md:mb-4" data-id="element-315">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-current" data-id="element-316" />)}
            </div>

            <p className={`mb-4 md:mb-6 italic text-sm md:text-lg leading-relaxed ${dark ? 'text-slate-300' : 'text-slate-700'}`} data-id="element-317">
              "{t.text}"
            </p>

            <div className="flex items-center" data-id="element-318">
              <div className={`w-9 h-9 md:w-12 md:h-12 rounded-full flex items-center justify-center text-white font-bold text-sm md:text-lg mr-3 md:mr-4 ${t.color}`} data-id="element-319">
                {t.initials}
              </div>
              <div data-id="element-320">
                <h4 className={`font-bold text-sm md:text-base ${dark ? 'text-white' : 'text-brand-dark'}`} data-id="element-321">
                  {t.name} — {t.location}
                </h4>
                <p className={`text-[10px] md:text-xs mt-0.5 md:mt-1 uppercase tracking-wider font-semibold ${dark ? 'text-slate-400' : 'text-slate-500'}`} data-id="element-322">
                  {t.role}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}